module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid20_800x635.6f0eda5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid20_800x635.jpg
// module id = 0jA1
// module chunks = 0